import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PageContainer, ContentWrapper, Title, Subtitle } from '../styles/SharedComponents';

// Declare fbq type for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}

// Estilização específica da página de loading
const LoadingContent = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoadingSpinner = styled(motion.div)`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #6e8efb;
  margin-bottom: 2rem;
`;

const Loading: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Simula o tempo de processamento e então redireciona para a página de resultados
    const timer = setTimeout(() => {
      navigate('/results');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <PageContainer>
      <LoadingContent>
        <LoadingSpinner
          animate={{ rotate: 360 }}
          transition={{
            repeat: Infinity,
            duration: 1,
            ease: "linear"
          }}
        />
        <Title>Analisando suas respostas...</Title>
        <Subtitle
          style={{ marginBottom: '1rem' }}
        >
          Estamos processando suas informações para encontrar as melhores opções de gateway de pagamento para seu negócio.
        </Subtitle>
      </LoadingContent>
    </PageContainer>
  );
};

export default Loading; 